import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { CheckListType, LanguageCode } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DwoCheckListGroupItemCheckboxMappingViewModel, DwoCheckListGroupItemRadiobuttonMappingViewModel } from '../../../business-entities/dwo-check-list-group-item-checkbox-mapping-view-model';
import { DwoCheckListGroupItemMappingViewModel, EditDwoCheckListGroupItemViewModel } from '../../../business-entities/dwo-check-list-group-item-mapping-view-model';
import { CheckboxObjectDetails, CheckListItemByMappingIdModel, RadiobuttonObjectDetails } from '../../../business-entities/dwo-check-list-request-model';
import { GenericResponse } from '../../../business-entities/generic-response';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import * as fromenums from './../../../../../../Autofacets-Core/src/app/utils/enums'

@Component({
  selector: 'app-add-multicplour-checklist-item',
  templateUrl: './add-multicplour-checklist-item.component.html',
  styleUrls: ['./add-multicplour-checklist-item.component.css']
})
export class AddMulticplourChecklistItemComponent implements OnInit {

 @Input() disabledInput:boolean = false;
  addCheckListItemForm: FormGroup;
  subCheckListTitle: string;
  languageList: any[];
  parentId: number;
  condition:boolean = false;
  checkListId:number;
  add: string;
  checkListtypeValue:number;
  isEditMode:boolean=false;
  editMode = false;
  sequenceValue : number ;
  hideshow:boolean = false;
  duplicateChecklist: boolean = false;
  currentUser: string;
  checkBox: CheckboxObjectDetails[] = [];
  checkListItems: CheckListItemByMappingIdModel;
  dwoCheckListGroupItemMappingViewModel: DwoCheckListGroupItemMappingViewModel;
  checkboxTitleList: Array<DwoCheckListGroupItemCheckboxMappingViewModel> = [];
  radiobuttonTitleList: Array<DwoCheckListGroupItemRadiobuttonMappingViewModel> = [];
  editdwoCheckListGroupItemMappingViewModel: EditDwoCheckListGroupItemViewModel;
  radioButton: RadiobuttonObjectDetails[] = [];
  isCheckBoxItem:boolean = false;
  isRadioButtonItem:boolean = false;
  radioBtnList: any = {
    radioBtnList: []
  }
  checkBoxList: any = {
    checkBoxList: []
  };
 multicolorSelectedvalue :boolean = false;
 CheckListItemDetails = [];
 popupCloseResult = false;
 SubCheckListItems = [];
 LanguageCode : any ;
 isSubmitted : boolean = false;
 userRoleRightsDetails: UserRoleMenu;
  constructor(private activeModal : NgbActiveModal,
    private checkListBusinessService: CheckListBusinessService,
    private formBuilder: FormBuilder,
    private currentLanguageService: CurrentLanguage,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService,
    private userService : UserDataService) {

  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromenums.ModuleNames.ChecklistManagement);
    this.languageList = this.currentLanguageService.LanguageList;
    this.checkListBusinessService.isEdit = true;
    this.addCheckListItemForm = this.formBuilder.group({
      checkListName:[''],
      colorcheckListType:[''],
      service: new FormArray([]),
      sequence: ['', [Validators.required,Validators.min(1), Validators.max(99)]],
      camaraAvailable: [false],
      textBox: [false],
      checkBox: [false],
      radioButton: [false],
      isQuestionActive: [false],
      checkbox: new FormArray([]),
      csequence: [''],
      radio: new FormArray([]),
      rsequence: [''],
      itemsequence:[''],
      photoGraphyDetails: [''],
      mappingId:['']
    })
    this.subCheckListTitle = this.checkListBusinessService.check;
    this.add = this.checkListBusinessService.IsAddItems;
     this.multicolorSelectedvalue = this.checkListBusinessService.multiColorSelect;
    this.getLanguage();
    this.parentId = this.checkListBusinessService.checkListItemId;
    this.getCheckListByMappingId(this.parentId);
    this.getColorCheckListItemsByMappingId(this.parentId);
    this.addCheckListItemForm.controls['colorcheckListType'].disable();
    this.LanguageCode = this.cookieservice.get('userSelectedLanguage')
  }

  get t() { return this.cpf.service as FormArray; }
  get c() { return this.cpf.checkbox as FormArray; }
  get r() { return this.cpf.radio as FormArray; }

  get cpf() {
    return this.addCheckListItemForm.controls;
  }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
           name: ['', [Validators.required]],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['',],
           name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }

    if (this.r.length < number) {
      for (let i = this.r.length; i < number; i++) {
        this.r.push(this.formBuilder.group({
          languageId: ['',],
           name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.r.length; i >= number; i--) {
        this.r.removeAt(i);
      }
    }
  }


  OnClose()
  {
    this.activeModal.close({success:true});
  }

  AddCheckListItems()
  {
    this.currentUser = this.userService.currentUserValue.userId;
    this.dwoCheckListGroupItemMappingViewModel =
    {
      id : 0 ,
      parentId: this.parentId,
      clType : fromenums.ClType.Generic,
      userId: this.currentUser,
      sequence: this.addCheckListItemForm.value.sequence,
      checkListGroupItemViewModel: {
        id: 0,
        mappingId: 0,
        makeCameraAvailable: this.addCheckListItemForm.value.camaraAvailable,
        isQuestionActive: this.addCheckListItemForm.value.isQuestionActive,
        checkListType: CheckListType.TYPE_4_RADIOBUTTON,
        colorcheckListType : this.checkListtypeValue,
        isMulticolorSelected :  this.multicolorSelectedvalue
      },
      checkListGroupItemDetailsViewModel: [
        {
          id: 0,
          mappingId: 0,
          subCheckListItemTitleDetails: this.addCheckListItemForm.value.service,
          photoGraphyDetails: this.addCheckListItemForm.value.photoGraphyDetails,
          sequence:this.addCheckListItemForm.value.sequence
        }
      ],
      checkListGroupItemCheckboxMappingViewModel: this.checkboxTitleList.length > 0 && this.addCheckListItemForm.value.checkBox ? this.checkboxTitleList : [],
      checkListGroupItemRadiobuttonMappingViewModel: this.radiobuttonTitleList.length > 0 && this.addCheckListItemForm.value.radioButton ? this.radiobuttonTitleList : []
     
    }
    this.checkListBusinessService.addCheckListItem(this.dwoCheckListGroupItemMappingViewModel).then((_response: GenericResponse<any>) => {
      this.cpf.service["controls"].forEach(frm => {
        frm["controls"].name.reset();
      });
      this.addCheckListItemForm.patchValue({
        sequence : '',
        isQuestionActive : false,
        camaraAvailable : false,
        photoGraphyDetails : '',
        mappingId : 0
      });
      this.isSubmitted = true;
      this.getColorCheckListItemsByMappingId(this.parentId);
      let successMsg = this.translate.instant("lblCheckListItemAdded");
      this.toastr.success(successMsg);
      this.spinner.hide();
    });

  }

  editCheckListMap(checkitem:any)
  {
     this.hideshow = true;
     const SequenceNumber  = checkitem.sequence;
     const cameraAvailable = checkitem.makeCameraAvailable;
     const questionActive = checkitem.isQuestionActive;
     const photoGraphyDetails = checkitem.photoGraphyDetails;
     let langFormData = [];
     checkitem.languageData.forEach(lan => {
       const fData = {
        languageId: lan.languageId,
        name: lan.titleName
       };
       langFormData.push(fData);
     });
     this.cpf.service.patchValue(langFormData);

     this.addCheckListItemForm.patchValue({
      sequence : SequenceNumber,
      isQuestionActive : questionActive,
      camaraAvailable : cameraAvailable,
      photoGraphyDetails : photoGraphyDetails,
      mappingId : checkitem.id
    })
    this.isEditMode = true;
  }

  deleteCheckList(id:number)
  {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblCheckListItem"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.currentUser = this.userService.currentUserValue.userId;
        let deleteRequestModel = { id: id, UserId: this.currentUser };
        this.checkListBusinessService.deleteCheckList(deleteRequestModel).then((response) => {
          this.getColorCheckListItemsByMappingId(this.parentId);
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblCheckListDeleted");
            this.toastr.success(successMsg)
          }
        });
      }
    })
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  getCheckListByMappingId(id: number) {
    let viewModel =
    {
      MappingId: id,
      LanguageCode: this.cookieservice.get('userSelectedLanguage')
    }
    this.checkListBusinessService.getCheckListByMappingId(viewModel).then((response) => {
      this.addCheckListItemForm.reset();
      if (response.responseCode === 200 && response.responseObject.errorCount === undefined) {
        if (response.responseObject !== undefined) {
          const resObj = response.responseObject;
          const checkListData = resObj.checklistDetails.find(x=>x.languageId == LanguageCode[viewModel.LanguageCode]);
          this.checkListtypeValue = response.responseObject.checkListByMappingId[0].colourCheckListType;
          this.sequenceValue = resObj.checkListByMappingId[0].sequence;
          this.addCheckListItemForm.patchValue({
            checkListName : checkListData.name,
            colorcheckListType : resObj.checkListByMappingId[0].colourCheckListType + ' Colour',
            sequence: resObj.checkListByMappingId[0].sequence,
            brandId: resObj.checkListByMappingId[0].brandId,
            vehicleTypeId: resObj.checkListByMappingId[0].vehicleTypeId,
            isActive: resObj.checkListByMappingId[0].isActive,
            service: resObj.checklistDetails,
            isMulticolorCheckListSelected: resObj.checkListByMappingId[0].isMulticolorCheckListSelected,
            duplicateChecklist: this.duplicateChecklist
          })
        }
      }
    });
  }

  onShow()
  {
    this.hideshow = true;
    this.cpf.service["controls"].forEach(frm => {
      frm["controls"].name.reset();
    });
    this.addCheckListItemForm.patchValue({
      sequence : '',
      isQuestionActive : false,
      camaraAvailable : false,
      photoGraphyDetails : '',
      mappingId : 0
    });
  }

  EditCheckListItems()
  {
    this.editdwoCheckListGroupItemMappingViewModel =
    {
      id : 0 ,
      parentId: this.addCheckListItemForm.value.mappingId,
      clType : fromenums.ClType.Generic,
      userId: this.currentUser,
      sequence: 0,
      checkListGroupItemViewModel: {
        id: 0,
        mappingId: this.addCheckListItemForm.value.mappingId,
        makeCameraAvailable: this.addCheckListItemForm.value.camaraAvailable,
        isQuestionActive: this.addCheckListItemForm.value.isQuestionActive,
        checkListType: CheckListType.TYPE_4_RADIOBUTTON,
        colorcheckListType : this.checkListtypeValue,
        isMulticolorSelected :  this.multicolorSelectedvalue
      },
      checkListGroupItemDetailsViewModel: [
        {
          id: 0,
          mappingId: this.addCheckListItemForm.value.mappingId,
          subCheckListItemTitleDetails: this.addCheckListItemForm.value.service,
          photoGraphyDetails: this.addCheckListItemForm.value.photoGraphyDetails,
          sequence:this.addCheckListItemForm.value.sequence
        }
      ],
      checkListGroupItemCheckboxMappingViewModel:  this.checkBoxList.checkBoxList.length > 0 ? this.checkBoxList.checkBoxList : null,
      checkListGroupItemRadiobuttonMappingViewModel: this.radioBtnList.radioBtnList.length > 0 ? this.radioBtnList.radioBtnList : null,
  }
  this.spinner.show();
  this.checkListBusinessService.updateCheckListItems(this.editdwoCheckListGroupItemMappingViewModel).then((_response: GenericResponse<any>) => {
    this.cpf.service["controls"].forEach(frm => {
      frm["controls"].name.reset();
    });
    this.addCheckListItemForm.patchValue({
      sequence : '',
      isQuestionActive : false,
      camaraAvailable : false,
      photoGraphyDetails : '',
      mappingId : 0
    });
    this.isEditMode = false;
    this.isSubmitted = true;
    this.getColorCheckListItemsByMappingId(this.parentId);
    let successMsg = this.translate.instant("lblCheckListItemUpdated");
    this.toastr.success(successMsg);
    this.spinner.hide();
  });
}

getColorCheckListItemsByMappingId(id: number) {
  this.spinner.show();
  this.checkBox = [];
  this.checkListBusinessService.getColorCheckListItemsByMappingId(id).then((response: GenericResponse<any>) => {
    if (response.responseCode === 200 && response.responseObject.errorCount === undefined) {
      const data = response.responseObject
      let checkListData = [];
      data.filter(x=>x.languageID == 1).forEach(element => {
        element["languageData"] = [];
        this.languageList.forEach(lan => {
          const lData = data.find(x=>x.id == element.id && x.languageID == lan.id);
          element["languageData"].push({
            languageId: lData.languageID,
            titleName: lData.subCheckListItemTitle
          });
        });
        checkListData.push(element);
      });
      this.CheckListItemDetails = checkListData;
    }
    this.spinner.hide();
  });
}

groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

}
